@if (!isMobile) {
  <gl-top-menu [workingTable]="workingTable"></gl-top-menu>
}
<router-outlet></router-outlet>
